
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaYCbqHQMAuERJqiREzAK63yjXoWzCk_li0jvxGr2LHwMeta } from "/usr/app/pages/index.vue?macro=true";
import { default as registerKo2QJQrQm8a7SQ8nbYIO2hUW7dALPi91ssygOJGNJAUMeta } from "/usr/app/pages/register.vue?macro=true";
import { default as settings5cYzFuP2xjbGCHsH2_45h9lk6Y86DISemTkFF8zyNmbJMMeta } from "/usr/app/pages/settings.vue?macro=true";
import { default as logsCqE3R85Z9Ho6llQTNbSamMeBospzbLDl8eDWkT2iFOIMeta } from "/usr/app/pages/admin/logs.vue?macro=true";
import { default as env_45mismatchIcUR_9_5k4caVPoE47FQqauQA_kldwSpKPdh5pXDHnkMeta } from "/usr/app/pages/env-mismatch.vue?macro=true";
import { default as attacksvthHXaBCRvnzpqEzYummSwZr0o84Jrh3MF6Q7TmKcy4Meta } from "/usr/app/pages/admin/attacks.vue?macro=true";
import { default as findingssJEFvf6JydcXAm5sL_45LSg6V05nKwKtcOazXrE5pntTkMeta } from "/usr/app/pages/admin/findings.vue?macro=true";
import { default as settingsmE__fyQTi2306z0jB0QhSXpnSGW58kOWA7nidJuw9OQMeta } from "/usr/app/pages/admin/settings.vue?macro=true";
import { default as graph_45explorerRoko5tdGyMIWFrX3bfUgOCpZhwUwyRgqPa5cjCiAg_454Meta } from "/usr/app/pages/admin/graph-explorer.vue?macro=true";
import { default as serviceproviderLBR5Ti3rn8ElY_iTrx1e4GeyWHwKGOyjXHc7DxYsDFkMeta } from "/usr/app/pages/admin/serviceprovider.vue?macro=true";
import { default as ioakfZB6Tmux8AK4HzDqcq6BpGPzE4quzjRue3_BRIcNcUMeta } from "/usr/app/pages/client/[clientId]/ioa.vue?macro=true";
import { default as installerLVhbAGP0J5GYhPsSD_3WWOR7JlnJG4RY0vEaXAacweIMeta } from "/usr/app/pages/meta/quickcheck/installer.vue?macro=true";
import { default as explorerFWD1fyICvrmEMYV_2IytNmk_45Pcxko2JfHZYkD8bwUKQMeta } from "/usr/app/pages/client/[clientId]/explorer.vue?macro=true";
import { default as indexzrxGuejTC5Eqykns0FSyhVBE_45aXT1P6V4OucW2_45yUOgMeta } from "/usr/app/pages/client/[clientId]/ioe/index.vue?macro=true";
import { default as auditsyxhK1UHgSDFqMyCaWkLOstYmliaWCNNMA1TVSnpjwsMeta } from "/usr/app/pages/provider/[providerId]/audit.vue?macro=true";
import { default as security_45logbtsyysDUzFfe3kRTNtntW3djs2m4WFRIhyT_KM1dD4UMeta } from "/usr/app/pages/client/[clientId]/security-log.vue?macro=true";
import { default as exceptionsZPSqDK8pSBHIRinuCjs0r5TNQlFcLvS_45DfZ_453Kdytp0Meta } from "/usr/app/pages/client/[clientId]/ioe/exceptions.vue?macro=true";
import { default as indexCKwcx_45JtIt56JnE2Mxu7P6ESUroYXemgLH0qWJlItnMMeta } from "/usr/app/pages/client/[clientId]/settings/index.vue?macro=true";
import { default as monitoringVe4KbHw5Dot5imJVrPJQT0UmWXMSQ_456qRbmDfnTbM_gMeta } from "/usr/app/pages/provider/[providerId]/monitoring.vue?macro=true";
import { default as quickcheckia7TJc28CBd_45sUvZ5gmy7M_PCZrfuWZFW0v3kiFxQ_45EMeta } from "/usr/app/pages/provider/[providerId]/quickcheck.vue?macro=true";
import { default as index4iDi8YrV2IVGc0jRFLLPFNBjZxyVYAmr_x5pappjaekMeta } from "/usr/app/pages/client/[clientId]/dashboard/index.vue?macro=true";
import { default as indexrAqWgOLcFsfh5DvFkS_45gOOCamTakynaJz6uRRt6ED_0Meta } from "/usr/app/pages/provider/[providerId]/settings/index.vue?macro=true";
import { default as indexMN1VQFYbYV_qK58wcANPHFR_45xiHoK8OtsAx3moJDUUgMeta } from "/usr/app/pages/client/[clientId]/change-history/index.vue?macro=true";
import { default as search6d42A3cN_45cqblbN4Lh0GLWC8y7PUAi0tDZu_45aPC1SF8Meta } from "/usr/app/pages/client/[clientId]/change-history/search.vue?macro=true";
import { default as _91_46_46_46slug_93N8DvbcBPLYJAMOhHAMW_QzdINyG__45S5R7BHoP6C7eHIMeta } from "/usr/app/pages/client/[clientId]/ioe/findings/[...slug].vue?macro=true";
import { default as thresholdsQ3UrQqNOSTJA79lmLCp0zJuMajvEleYDnmMStQs0lokMeta } from "/usr/app/pages/client/[clientId]/settings/ioa/thresholds.vue?macro=true";
import { default as thresholdsHs7Xcv1GVS2F6xZ00lr7IspXPZSrdSbs_c2XRLn9XnQMeta } from "/usr/app/pages/client/[clientId]/settings/ioe/thresholds.vue?macro=true";
import { default as criticalitiesQFli99vxMErSm5nlc610MJPfriqdbrKwFjq08ztes1IMeta } from "/usr/app/pages/client/[clientId]/settings/ioe/criticalities.vue?macro=true";
import { default as gpo_45reg_45autologinjoaRPqkO_45zf0f4uTGBqjk5zkCgrS3OBwyF76jJPZvHgMeta } from "/usr/app/pages/client/[clientId]/ioe/findings/gpo-reg-autologin.vue?macro=true";
import { default as group_45rodc_45not_45emptyx6H5wlo77OUCgR7GxL_45M_xQcgv3dCYRTXy6OQU5CQtIMeta } from "/usr/app/pages/client/[clientId]/ioe/findings/group-rodc-not-empty.vue?macro=true";
import { default as gpo_45lanmanager_45enabledLe0IWqVlo4NC8djKkNd2kix4cw3ecSZHa54AOQqppmoMeta } from "/usr/app/pages/client/[clientId]/ioe/findings/gpo-lanmanager-enabled.vue?macro=true";
import { default as gpo_45weak_45password_45policyFkta4981Hh1upIk5XQeI0Q2pfvpj9NHdUVsPkCywnqcMeta } from "/usr/app/pages/client/[clientId]/ioe/findings/gpo-weak-password-policy.vue?macro=true";
import { default as password_45like_45string_45foundWhLENWwwNRdK_457LKhHTJP3WbOXSVYhsDR52dv1ErXaEMeta } from "/usr/app/pages/client/[clientId]/ioe/findings/password-like-string-found.vue?macro=true";
import { default as object_45duplicated_45samaccountnameReUc5c9U0BhprVyuu_VX4Eo8qzPYDecakdgWifwljJEMeta } from "/usr/app/pages/client/[clientId]/ioe/findings/object-duplicated-samaccountname.vue?macro=true";
import { default as entra_45legacy_45authentication_45allowedycXvKJKRmmThuLtlE9leZQbNbM2sv2G7YoMH_457_45Yz44Meta } from "/usr/app/pages/client/[clientId]/ioe/findings/entra-legacy-authentication-allowed.vue?macro=true";
import { default as entra_45security_45defaults_45not_45enableddN8M45XH_1lTN7qV2Piqy5lVkeZMpV6ztnihZtIxLAYMeta } from "/usr/app/pages/client/[clientId]/ioe/findings/entra-security-defaults-not-enabled.vue?macro=true";
import { default as computer_45dc_45no_45constrained_45delegationWYA9EGKdAyXq_e8cZY1hEbJMU0GwaouWVQl7TvFP9VsMeta } from "/usr/app/pages/client/[clientId]/ioe/findings/computer-dc-no-constrained-delegation.vue?macro=true";
import { default as entra_45no_45device_45compliance_45conditional_45accessZyBfAp4qm59dZPfuG9qgGCaOfg4J2Tja_Ju2FwU9buoMeta } from "/usr/app/pages/client/[clientId]/ioe/findings/entra-no-device-compliance-conditional-access.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/app/pages/index.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerKo2QJQrQm8a7SQ8nbYIO2hUW7dALPi91ssygOJGNJAUMeta || {},
    component: () => import("/usr/app/pages/register.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: settings5cYzFuP2xjbGCHsH2_45h9lk6Y86DISemTkFF8zyNmbJMMeta || {},
    component: () => import("/usr/app/pages/settings.vue")
  },
  {
    name: "admin-logs",
    path: "/admin/logs",
    meta: logsCqE3R85Z9Ho6llQTNbSamMeBospzbLDl8eDWkT2iFOIMeta || {},
    component: () => import("/usr/app/pages/admin/logs.vue")
  },
  {
    name: "env-mismatch",
    path: "/env-mismatch",
    meta: env_45mismatchIcUR_9_5k4caVPoE47FQqauQA_kldwSpKPdh5pXDHnkMeta || {},
    component: () => import("/usr/app/pages/env-mismatch.vue")
  },
  {
    name: "admin-attacks",
    path: "/admin/attacks",
    meta: attacksvthHXaBCRvnzpqEzYummSwZr0o84Jrh3MF6Q7TmKcy4Meta || {},
    component: () => import("/usr/app/pages/admin/attacks.vue")
  },
  {
    name: "admin-findings",
    path: "/admin/findings",
    meta: findingssJEFvf6JydcXAm5sL_45LSg6V05nKwKtcOazXrE5pntTkMeta || {},
    component: () => import("/usr/app/pages/admin/findings.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    meta: settingsmE__fyQTi2306z0jB0QhSXpnSGW58kOWA7nidJuw9OQMeta || {},
    component: () => import("/usr/app/pages/admin/settings.vue")
  },
  {
    name: "admin-graph-explorer",
    path: "/admin/graph-explorer",
    meta: graph_45explorerRoko5tdGyMIWFrX3bfUgOCpZhwUwyRgqPa5cjCiAg_454Meta || {},
    component: () => import("/usr/app/pages/admin/graph-explorer.vue")
  },
  {
    name: "admin-serviceprovider",
    path: "/admin/serviceprovider",
    meta: serviceproviderLBR5Ti3rn8ElY_iTrx1e4GeyWHwKGOyjXHc7DxYsDFkMeta || {},
    component: () => import("/usr/app/pages/admin/serviceprovider.vue")
  },
  {
    name: "client-clientId-ioa",
    path: "/client/:clientId()/ioa",
    component: () => import("/usr/app/pages/client/[clientId]/ioa.vue")
  },
  {
    name: "meta-quickcheck-installer",
    path: "/meta/quickcheck/installer",
    meta: installerLVhbAGP0J5GYhPsSD_3WWOR7JlnJG4RY0vEaXAacweIMeta || {},
    component: () => import("/usr/app/pages/meta/quickcheck/installer.vue")
  },
  {
    name: "client-clientId-explorer",
    path: "/client/:clientId()/explorer",
    component: () => import("/usr/app/pages/client/[clientId]/explorer.vue")
  },
  {
    name: "client-clientId-ioe",
    path: "/client/:clientId()/ioe",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/index.vue")
  },
  {
    name: "provider-providerId-audit",
    path: "/provider/:providerId()/audit",
    meta: auditsyxhK1UHgSDFqMyCaWkLOstYmliaWCNNMA1TVSnpjwsMeta || {},
    component: () => import("/usr/app/pages/provider/[providerId]/audit.vue")
  },
  {
    name: "client-clientId-security-log",
    path: "/client/:clientId()/security-log",
    meta: security_45logbtsyysDUzFfe3kRTNtntW3djs2m4WFRIhyT_KM1dD4UMeta || {},
    component: () => import("/usr/app/pages/client/[clientId]/security-log.vue")
  },
  {
    name: "client-clientId-ioe-exceptions",
    path: "/client/:clientId()/ioe/exceptions",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/exceptions.vue")
  },
  {
    name: "client-clientId-settings",
    path: "/client/:clientId()/settings",
    component: () => import("/usr/app/pages/client/[clientId]/settings/index.vue")
  },
  {
    name: "provider-providerId-monitoring",
    path: "/provider/:providerId()/monitoring",
    meta: monitoringVe4KbHw5Dot5imJVrPJQT0UmWXMSQ_456qRbmDfnTbM_gMeta || {},
    component: () => import("/usr/app/pages/provider/[providerId]/monitoring.vue")
  },
  {
    name: "provider-providerId-quickcheck",
    path: "/provider/:providerId()/quickcheck",
    meta: quickcheckia7TJc28CBd_45sUvZ5gmy7M_PCZrfuWZFW0v3kiFxQ_45EMeta || {},
    component: () => import("/usr/app/pages/provider/[providerId]/quickcheck.vue")
  },
  {
    name: "client-clientId-dashboard",
    path: "/client/:clientId()/dashboard",
    component: () => import("/usr/app/pages/client/[clientId]/dashboard/index.vue")
  },
  {
    name: "provider-providerId-settings",
    path: "/provider/:providerId()/settings",
    meta: indexrAqWgOLcFsfh5DvFkS_45gOOCamTakynaJz6uRRt6ED_0Meta || {},
    component: () => import("/usr/app/pages/provider/[providerId]/settings/index.vue")
  },
  {
    name: "client-clientId-change-history",
    path: "/client/:clientId()/change-history",
    component: () => import("/usr/app/pages/client/[clientId]/change-history/index.vue")
  },
  {
    name: "client-clientId-change-history-search",
    path: "/client/:clientId()/change-history/search",
    component: () => import("/usr/app/pages/client/[clientId]/change-history/search.vue")
  },
  {
    name: "client-clientId-ioe-findings-slug",
    path: "/client/:clientId()/ioe/findings/:slug(.*)*",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/[...slug].vue")
  },
  {
    name: "client-clientId-settings-ioa-thresholds",
    path: "/client/:clientId()/settings/ioa/thresholds",
    component: () => import("/usr/app/pages/client/[clientId]/settings/ioa/thresholds.vue")
  },
  {
    name: "client-clientId-settings-ioe-thresholds",
    path: "/client/:clientId()/settings/ioe/thresholds",
    component: () => import("/usr/app/pages/client/[clientId]/settings/ioe/thresholds.vue")
  },
  {
    name: "client-clientId-settings-ioe-criticalities",
    path: "/client/:clientId()/settings/ioe/criticalities",
    component: () => import("/usr/app/pages/client/[clientId]/settings/ioe/criticalities.vue")
  },
  {
    name: "client-clientId-ioe-findings-gpo-reg-autologin",
    path: "/client/:clientId()/ioe/findings/gpo-reg-autologin",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/gpo-reg-autologin.vue")
  },
  {
    name: "client-clientId-ioe-findings-group-rodc-not-empty",
    path: "/client/:clientId()/ioe/findings/group-rodc-not-empty",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/group-rodc-not-empty.vue")
  },
  {
    name: "client-clientId-ioe-findings-gpo-lanmanager-enabled",
    path: "/client/:clientId()/ioe/findings/gpo-lanmanager-enabled",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/gpo-lanmanager-enabled.vue")
  },
  {
    name: "client-clientId-ioe-findings-gpo-weak-password-policy",
    path: "/client/:clientId()/ioe/findings/gpo-weak-password-policy",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/gpo-weak-password-policy.vue")
  },
  {
    name: "client-clientId-ioe-findings-password-like-string-found",
    path: "/client/:clientId()/ioe/findings/password-like-string-found",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/password-like-string-found.vue")
  },
  {
    name: "client-clientId-ioe-findings-object-duplicated-samaccountname",
    path: "/client/:clientId()/ioe/findings/object-duplicated-samaccountname",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/object-duplicated-samaccountname.vue")
  },
  {
    name: "client-clientId-ioe-findings-entra-legacy-authentication-allowed",
    path: "/client/:clientId()/ioe/findings/entra-legacy-authentication-allowed",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/entra-legacy-authentication-allowed.vue")
  },
  {
    name: "client-clientId-ioe-findings-entra-security-defaults-not-enabled",
    path: "/client/:clientId()/ioe/findings/entra-security-defaults-not-enabled",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/entra-security-defaults-not-enabled.vue")
  },
  {
    name: "client-clientId-ioe-findings-computer-dc-no-constrained-delegation",
    path: "/client/:clientId()/ioe/findings/computer-dc-no-constrained-delegation",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/computer-dc-no-constrained-delegation.vue")
  },
  {
    name: "client-clientId-ioe-findings-entra-no-device-compliance-conditional-access",
    path: "/client/:clientId()/ioe/findings/entra-no-device-compliance-conditional-access",
    component: () => import("/usr/app/pages/client/[clientId]/ioe/findings/entra-no-device-compliance-conditional-access.vue")
  }
]